import avatar1 from "/assets/images/avatar1.webp";
import avatar2 from "/assets/images/avatar2.webp";
import avatar3 from "/assets/images/avatar3.webp";
import avatar4 from "/assets/images/avatar4.webp";

export const reviewsData = [
  {
    name: "review.0.name",
    role: "review.0.role",
    text: "review.0.text",
    avatar: avatar1,
  },
  {
    name: "review.1.name",
    role: "review.1.role",
    text: "review.1.text",
    avatar: avatar2,
  },
  {
    name: "review.2.name",
    role: "review.2.role",
    text: "review.2.text",
    avatar: avatar3,
  },
  {
    name: "review.3.name",
    role: "review.3.role",
    text: "review.3.text",
    avatar: avatar4,
  },
];
